import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { clearAuditChanged } from '../../redux/reducer/coreScriptReducer';
import { RootState } from '../../redux/Store';
import { contextValue } from '../../constants';

export const handleSendMessageStatus = (data: {
  SubmitComplete: boolean;
  Followup: boolean;
  AuditSaved: string | number;
  Context: string;
  ContextKey: string;
  ContextId: string;
}) => {
  if (!data || !data.Context) {
    return;
  }

  if (
    data.Context === contextValue.AuditResults ||
    data.Context === contextValue.AuditRequest
  ) {
    //These context are spending status back to spiglass iframe
    const targetWindow = window.parent;
    if (targetWindow) {
      const hostname = globalThis.location.hostname;
      // Replace 'safeview' with 'spiglass' in the hostname
      const targetHostname = hostname.replace('safeview', 'spiglass');

      targetWindow.postMessage(data, `https://${targetHostname}`);
    }
  }

  return;
};

const useContextQueryObj = () => {
  return useSelector((state: RootState) => state.contextId.queryObj);
};
export const useSinglePostMessage = (stateData: any) => {
  const dispatch = useDispatch();

  const queryObj = useContextQueryObj();
  const hasSentMessage = useRef(false);
  const prevAuditChanged = useRef(stateData?.AuditChanged);

  useEffect(() => {
    // Check if AuditChanged has changed
    if (stateData?.AuditChanged !== prevAuditChanged.current) {
      // Update the ref to the current value
      prevAuditChanged.current = stateData?.AuditChanged;

      if (stateData?.AuditChanged && !hasSentMessage.current) {
        handleSendMessageStatus({
          SubmitComplete: false,
          AuditSaved: stateData?.AuditSaved,
          Followup: stateData?.Followup,
          Context: `${queryObj?.context}`,
          ContextId: `${queryObj?.id}`,
          ContextKey: `${queryObj?.key}`,
        });
        dispatch(clearAuditChanged());
        hasSentMessage.current = true;
      }

      if (!stateData?.AuditChanged) {
        hasSentMessage.current = false;
      }
    }
  }, [
    stateData?.AuditChanged,
    dispatch,
    stateData,
    queryObj?.context,
    queryObj?.id,
    queryObj?.key,
  ]);
};
// export default useSinglePostMessage;

// export default handleSendMessageStatus;
